'use client';
// libs
import { HTMLProps, ReactElement } from 'react';
import { useSession } from 'next-auth/react';
import { useGetAccount } from 'app-shared/lib/api/user-access';
import { hasValidAccessToken } from 'app-shared/lib/api/user-access/auth/access-token.utils';
import { context } from './account.context';

export function AccountProvider(props: HTMLProps<HTMLDivElement>): ReactElement {
  const { children } = props;
  const { data: session } = useSession();
  const hasSessionWithValidAccessToken = hasValidAccessToken(session);
  const { data: account, isValidating: isAccountLoading } = useGetAccount(hasSessionWithValidAccessToken);

  return (
    <context.Provider
      value={{
        account,
        isAccountLoading,
      }}
    >
      {children}
    </context.Provider>
  );
}

export default AccountProvider;
